"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classSkillModel = exports.unlearnedClassSkill = exports.craftingSkill = exports.default = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var classSkillModel = {
  id: "growUp",
  isEnabled: true,
  costHealth: 0,
  costHealthLevelMultiplier: 0,
  costMana: 10,
  costManaLevelMultiplier: 10,
  costStamina: 10,
  costStaminaLevelMultiplier: 10,
  i18nName: {
    en: "Grow Up",
    de: "Wachstum"
  },
  i18nDescription: {
    en: "A skill that temporarily increaes the main attributes of the the target my [M1] for [M2] seconds.",
    de: ""
  },
  iconFileName: "growup.gif",
  isCraftingSkill: false,
  isPassive: false,
  range: 0,
  rechargingTimeMaxSecs: 10,
  requiresItemTypes: [],
  soundFileName: "growup.mp3"
};
exports.classSkillModel = classSkillModel;
var craftingSkillModel = Object.create(classSkillModel);
craftingSkillModel.isPassive = true;
craftingSkillModel.iconFileName = "elaboration.gif";
craftingSkillModel.id = "design";
craftingSkillModel.i18nName.en = "Design";
craftingSkillModel.i18nName.de = "Design";
craftingSkillModel.i18nDescription.en = "Passive skill that increases the quality of items";
var classSkill = {
  id: 234234234,
  level: 10,
  expPerc: 42,
  experience: 2345345,
  producedActiveStatusEffects: [],
  rechargingTimeSecs: 20,
  usedCount: 1,
  windowPage: 1,
  windowPosX: 1,
  windowPosY: 1,
  model: classSkillModel
};

var craftingSkill = _objectSpread({}, classSkill);

exports.craftingSkill = craftingSkill;
craftingSkill.model = craftingSkillModel;
craftingSkill.level = 20;
craftingSkill.expPerc = 100;
craftingSkill.windowPosX = 1;
craftingSkill.windowPosY = 1;
var unlearnedClassSkill = {
  id: 345345,
  level: 0,
  expPerc: 0,
  experience: 2345345,
  producedActiveStatusEffects: [],
  rechargingTimeSecs: 4,
  usedCount: 1,
  windowPage: 2,
  windowPosX: 2,
  windowPosY: 3,
  model: classSkillModel
};
exports.unlearnedClassSkill = unlearnedClassSkill;
var _default = classSkill;
exports.default = _default;